export default __webpack_public_path__ + "static/media/veluub.9499daa5.png";